import { createApp } from 'vue';
import Banner from '../components/top/Banner.vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';

import 'swiper/css';

const app = createApp({
    components: {
        'banner-component': Banner
    },
    data() {
        return {
            'banners': Array
        }
    }
})

app.use(VueAwesomeSwiper)
app.mount('#banner')